
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  TrendingUp, 
  DollarSign, 
  BarChart3, 
  Target
} from 'lucide-react';

interface DashboardMetricsCardsProps {
  netWorth: number;
  portfolioValue: number;
  npv: number;
  roiMetrics: { roi: number };
}

export function DashboardMetricsCards({ 
  netWorth, 
  portfolioValue, 
  npv, 
  roiMetrics 
}: DashboardMetricsCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Net Worth</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${netWorth.toLocaleString()}
          </div>
          <p className="text-xs text-muted-foreground">
            Assets - Liabilities
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Portfolio Value</CardTitle>
          <Target className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${portfolioValue.toLocaleString()}
          </div>
          <p className="text-xs text-muted-foreground">
            Total resource value
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Project NPV</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${npv.toLocaleString()}
          </div>
          <p className="text-xs text-muted-foreground">
            Net Present Value
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">ROI</CardTitle>
          <BarChart3 className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {roiMetrics.roi.toFixed(1)}%
          </div>
          <p className="text-xs text-muted-foreground">
            Return on Investment
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
